import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import type { Swiper as SwiperType } from "swiper";
import NoticiaCard from "./NoticiaCard";

interface NoticiaData {
  ID: number;
  Title: string;
  Descricao: string;
  Categoria?: {
    Title: string;
  };
  DataInicio: string;
  UrlIcone: string;
}

interface NoticiaSwiperProps {
  noticias: NoticiaData[];
  swiperIndex: number;
}

const NoticiaSwiper: React.FC<NoticiaSwiperProps> = ({
  noticias,
  swiperIndex,
}) => {
  return (
    <div className="noticias-swiper-container">
      <Swiper
        grabCursor={true}
        slidesPerView={4}
        spaceBetween={0}
        initialSlide={swiperIndex}
        pagination={{
          clickable: true,
          el: ".noticias-swiper-pagination",
        }}
        centeredSlides={false}
        allowTouchMove={true}
        watchOverflow={true}
        loop={false}
        breakpoints={{
          320: {
            slidesPerView: 1, // 1 card completo em mobile pequeno
            spaceBetween: 0,
            centeredSlides: true, // Centraliza o card
            initialSlide: 0,
          },
          480: {
            slidesPerView: 1, // 1 card completo em mobile pequeno
            spaceBetween: 0,
            centeredSlides: true, // Centraliza o card
            initialSlide: 0,
          },
          768: {
            slidesPerView: 2, // 2 cards em mobile/tablet
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          991: {
            slidesPerView: 2, // 2 cards ao lado do texto
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          1200: {
            slidesPerView: 3, // 3 cards em desktop médio
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          1400: {
            slidesPerView: 4, // 4 cards em desktop grande
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
        }}
        style={{
          width: "100%",
          overflow: "visible",
        }}
      >
        {noticias.map((noticia, index) => (
          <SwiperSlide
            key={`noticia-${noticia.ID}-${index}`}
            style={{
              width: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <NoticiaCard item={noticia} />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Div para as bolinhas de paginação */}
      <div className="noticias-swiper-pagination"></div>
    </div>
  );
};

export default NoticiaSwiper;
